module.exports = __webpack_public_path__ + "img/logo_sspp_black_narrow.d700e07d.png";